var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "6" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.order.invoiceNumber")) + ":"
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.InvoiceNumber))
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.order.enterWaybill"),
                      active: ""
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentDate,
                                    "date",
                                    "insert.order.documentDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentTime,
                                    "text",
                                    "insert.order.documentTime"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ActualDeliveryDate,
                                    "date",
                                    "insert.order.actualDeliveryDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ActualyDeliveryTime
                                      ? _vm.rowData.ActualyDeliveryTime
                                      : new Date().toTimeString().slice(0, 5),
                                    "text",
                                    "insert.order.actualDeliveryTime"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Customer,
                                    "object",
                                    "insert.order.customer"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.PriceList,
                                    "object",
                                    "insert.order.priceList"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentNumber,
                                    "text",
                                    "insert.order.documentNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.RefDocumentType,
                                    "object",
                                    "insert.order.refDocumentType"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Description1,
                                    "text",
                                    "insert.order.description1"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.EDocumentStatus,
                                    "object",
                                    "insert.order.eDocumentStatus"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Representative,
                                    "object",
                                    "insert.order.representative"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DeliveryRepresentative,
                                    "object",
                                    "insert.order.deliveryRepresentative"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Route,
                                    "object",
                                    "insert.order.route"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Warehouse,
                                    "object",
                                    "insert.order.warehouse"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Vehicle,
                                    "object",
                                    "insert.order.vehicle"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.rowData.RefDocumentType &&
                (_vm.rowData.RefDocumentType.Code === "WarehouseMovement" ||
                  _vm.rowData.RefDocumentType.Code === "VanLoading")
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("insert.order.products") } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12", md: "12" } },
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "m-4 asc__showPage-card" },
                                  [
                                    _c("NextExportDetail", {
                                      attrs: {
                                        url:
                                          "VisionNextCommonApi/api/DispatchRefDocument/ExcelExportItems",
                                        "record-id": _vm.rowData.RecordId,
                                        "record-key": "recordId",
                                        "file-name": _vm.$t(
                                          "insert.order.enterProducts"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-table-simple",
                                      { attrs: { bordered: "", small: "" } },
                                      [
                                        _c(
                                          "b-thead",
                                          [
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.productCode"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.productName"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.quantity"
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tbody",
                                          _vm._l(_vm.products, function(p, i) {
                                            return _c(
                                              "b-tr",
                                              { key: i },
                                              [
                                                _c("b-td", [
                                                  _vm._v(_vm._s(p.ItemCode))
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _vm._v(_vm._s(p.ItemDesc))
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _vm._v(_vm._s(p.Quantity))
                                                ])
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rowData.RefDocumentType &&
                _vm.rowData.RefDocumentType.Code === "AssetMovement"
                  ? _c(
                      "b-tab",
                      {
                        attrs: { title: _vm.$t("insert.order.assetMovement") }
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12", md: "12" } },
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "m-4 asc__showPage-card" },
                                  [
                                    _c(
                                      "b-table-simple",
                                      { attrs: { bordered: "", small: "" } },
                                      [
                                        _c(
                                          "b-thead",
                                          [
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.assetCode"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.assetName"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.serialNumber"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.assetQuantity"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.barcode"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("b-th", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.order.fixtureNumber"
                                                    )
                                                  )
                                                )
                                              ])
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-tbody",
                                          _vm._l(
                                            _vm.rowData.AssetMovementItems,
                                            function(a, i) {
                                              return _c(
                                                "b-tr",
                                                { key: i },
                                                [
                                                  _c("b-td", [
                                                    _vm._v(_vm._s(a.Code))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(a.Description)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(a.SerialNumber2)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-td", [
                                                    _vm._v(_vm._s(a.Quantity))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(a.SerialNumber)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-td", [
                                                    _vm._v(
                                                      _vm._s(a.SerialNumber3)
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.order.logisticCompanyInformation")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.order.companyName"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.taxNumber")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.city")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.order.district")
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(
                                        _vm.rowData.InvoiceLogisticCompanies,
                                        function(l, i) {
                                          return _c(
                                            "b-tr",
                                            { key: i },
                                            [
                                              _c("b-td", [
                                                _vm._v(_vm._s(l.CompanyName))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(_vm._s(l.TaxNumber))
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    l.City ? l.City.Label : "-"
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("b-td", [
                                                _vm._v(
                                                  _vm._s(
                                                    l.District
                                                      ? l.District.Label
                                                      : "-"
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7659ce47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7659ce47","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DispatchRefDocument/get.vue
// module id = null
// module chunks = 